import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { Gender } from '@customTypes/Generic'
import useStyles from './styles'
import { getQueryParams } from 'src/utils/getQueryParams'
import { TEST_IDS } from 'src/constants/testIds'

export const CustomerLastName = () => {
  const classes = useStyles()
  const { t } = useTranslation()
  const queryParams = getQueryParams()

  const salutation = useMemo(() => {
    if (queryParams?.customerGenderType === Gender.MALE) {
      return t('mr')
    }
    if (queryParams?.customerGenderType === Gender.FEMALE) {
      return t('mrs')
    }
  }, [queryParams, t])

  if (!queryParams?.customerLastName) {
    return null
  }

  return (
    <div className={classes.header} data-test={TEST_IDS.customerLastName}>
      {salutation} {queryParams?.customerLastName}
    </div>
  )
}
